import React, { Component } from 'react';
// import { database } from './App';

const Context = React.createContext();

const reducer = (state, action) => {
  switch (action.type) {
    case '':
      return {};
    default: {
      return state;
    }
  }
};

export class Provider extends Component {
  state = {
    restaurant_name: '',
    messenger_user_id: '',
    dispatch: action => this.setState(state => reducer(state, action))
  };

  render() {
    return (
      <Context.Provider value={this.state}>
        {this.props.children}
      </Context.Provider>
    );
  }
}

export const Consumer = Context.Consumer;



// WEBPACK FOOTER //
// ./src/Context.js